// Generated by GitHub Copilot
import configuration from "./index";
import { authFetch } from "../utils/authFetch";

export const ConfigurationAPI = {
  get: async function () {
    const configAPI = configuration.apiBase + `/library/configuration`;
    // Generated by GitHub Copilot - Use authFetch to handle 401 errors
    const response = await authFetch(configAPI);
    return await response.json();
  },
};
